import { useState, useEffect, useCallback } from "react"

import Grid from '@material-ui/core/Grid'
import Dialog from "@base/Dialog";
import { ButtonSave } from "@base/Button/ButtonForm"
import TextField from '@base/Inputs/Text'

import EmpresaService from '@services/EmpresaService'

export const EmpresaDialog = (props) => {
	const [formNome, setFormNome] = useState("");

	const submit = () => {
		let obj = {
			nome: formNome,
		};

		if (formNome === "") {
			props.toastRef.current.show("error", "O campo 'nome' é obrigatório.");
		} else {
			props.handleLoading(true);

			if (props.id) {
				EmpresaService.editar(props.id, obj).then(resp => {

					props.aoSalvar("Empresa alterada com sucesso!");

					limparFormulario();

				}).catch((error) => {
					props.toastRef.current.show("error", error.response.data.mensagens.map(m => m).join('<br/>'));
				}).finally(() => {
					props.handleLoading(false);
				});
			} else {
				EmpresaService.adicionar(obj).then(resp => {
					props.toastRef.current.show("success", "Empresa adicionada com sucesso!");

					props.aoSalvar("Empresa adicionada com sucesso!");

					limparFormulario();

				}).catch((error) => {
					props.toastRef.current.show("error", error.response.data.mensagens.map(m => m).join('<br/>'));
				}).finally(() => {
					props.handleLoading(false);
				});
			}
		}
	}

	const limparFormulario = () => {
		setFormNome("");
	}

	const fecharDialog = () => {
		limparFormulario();
		props.aoFechar();
	}

	const carregarDados = useCallback(() => {
		if (props.id) {
			EmpresaService.buscarPorId(props.id).then(resultado => {
				setFormNome(resultado.data.nome);
			}).catch(error => props.toastRef.current.show("error", "Ocorreu um Problema ao Buscar Empresa!"));;
		}
	}, [props]);

	useEffect(() => carregarDados(), [carregarDados]);

	return (<>
		<Dialog
			maxWidth={"sm"}
			fullWidth={true}
			closeDialog={fecharDialog}
			openDialog={props.aberto && (!props.loading)}
			title={props.id ? "Editar Empresa" : "Cadastrar Empresa"}
			actions={<ButtonSave onClick={submit} loading={props.loading} />}>

			<Grid container spacing={12}>
				<Grid item sm={6}>
					<TextField
						label="Nome"
						value={formNome}
						onChange={(e) => setFormNome(e.target.value.toUpperCase())}
					/>
				</Grid>
			</Grid>
		</Dialog>
	</>
	);
}

export default EmpresaDialog;
